import React, {Component} from 'react';
import '../css/views/locationsProfile.css';
import '../css/theme/mainContent.css';
import '../css/theme/forms.css';
import '../css/theme/forms-block.css';
import '../css/theme/buttons.css';

import LocationListing from '../components/LocationListing';
import { AppContext } from "../context/app-context";
import CreateEditLocationsModalWrapper from "../components/modals/modal-wrappers/CreateEditLocationsModalWrapper";
import {createLogoutOnFailureHandler} from '../util/LogoutUtil'
import Busy from "../components/Busy";
import {toast} from "react-toastify";
import {sanitizeData} from "../util/DataSanitizerUtil";

import 'bxslider/dist/jquery.bxslider.min';
import 'bxslider/dist/jquery.bxslider.min.css';
import EmailVerifyToolTip from "../components/notifications/EmailVerifyToolTip";
import { useNavigate } from 'react-router';
import { useFeatureFlags } from '../hooks/routing/useFeatureFlags';

const $ = window.$;

class LocationsProfile extends Component {

    static contextType = AppContext

    constructor(props, context) {
        super(props, context);

        const appContext = this.context
        const { user } = appContext

        this.state = {
            accountId: user.id,
            showHelp: 1,
            globalLocations: [],
            locationToEdit: null,
            selectedSupplier: null,
            createEditModalOpen: false,
        };
    }

    handleEditLocation = (location) => {
        // When the Create Location Wizard is enabled, edit a location in the new
        // full-page wizard instead of the legacy modal.
        if (this.props.createLocationWizard) {
            this.props.navigate(`/locations/${location.id}/edit`);
            return;
        }
        this.setState({locationToEdit: location})
    }

    handleSelectedSupplier = (selectedSupplier) => {
        this.setState({selectedSupplier})
    }

    setModalVisibility = (visible) => {
        this.setState({createEditModalOpen: visible})
    }

    openCreateEditModal = () => {
        // Suppress the legacy modal when the wizard handles edit navigation.
        if (this.props.createLocationWizard) {
            return;
        }
        this.setModalVisibility(true)
    }

    hideCreateEditModal = () => {
        this.setModalVisibility(false)
    }

    handleCreateNewClick = () => {
        // When the Create Location Wizard is enabled, route to the new full-page
        // wizard instead of opening the legacy create/edit modal.
        if (this.props.createLocationWizard) {
            this.props.navigate('/locations/create');
            return;
        }
        this.setState({
            locationToEdit: null,
            createEditModalOpen: true
        })
    }

    componentDidMount() {
        if (this.bxslider) {
            this.bxslider.destroySlider();
        }
        this.startSlider();
        this.fetchLocations();
        $('html,body').scrollTop(0);
    }

    fetchLocations() {
        Busy.set(true);
        $.ajax({
            url: 'api/location',
            type: 'GET',
            success: this.fetchLocationsSuccess,
            statusCode: {
                401: createLogoutOnFailureHandler()
            },
            error: this.fetchLocationsFailure,
            complete: function(){
            }
        });
    }

    fetchLocationsSuccess = data => {
        Busy.set(false);
        this.setState({
            globalLocations: data ? data : []
        });
    };

    fetchLocationsFailure = (jqXHR) => {
        Busy.set(false);
        if (jqXHR.status === 401) {
            return;
        }
        this.setState({
            globalLocations: []
        });
        toast.error(LocationsProfile.getErrorMessage(jqXHR));
    };

    static getErrorMessage(jqXHR) {
        let jsonErrorMessage = jqXHR.responseJSON ? jqXHR.responseJSON.message : null
        let trimmedJsonErrorMessage = jsonErrorMessage ? jsonErrorMessage.split(' ').join('') : null;
        return trimmedJsonErrorMessage ? trimmedJsonErrorMessage : "Internal Server Error";
    }

    handleDeactivateLocationSuccess = location => {
        let locations = this.state.globalLocations;
        for (let i = 0; i < locations.length; i++) {
            if (locations[i] === location) {
                locations.splice(i, 1);
            }
        }
        Busy.set(false);
        this.setState({
            globalLocations: locations
        });
        this.fetchLocations();
        toast.success(`Successfully deactivated ${location.locationName}!` );
    };

    handleDeleteLocationSuccess = location => {
        let locations = this.state.globalLocations;
        for (let i = 0; i < locations.length; i++) {
            if (locations[i] === location) {
                locations.splice(i, 1);
            }
        }
        Busy.set(false);
        this.setState({
            globalLocations: locations
        });
        this.fetchLocations();
        toast.success(`Successfully deleted ${location.locationName}!` );
    };

    handleDeactivateLocationFailure = errorMessage => {
        Busy.set(false);
        toast.error('Failed to deactivate location.  Reason:  ' + errorMessage);
    };

    handleDeleteLocationFailure = errorMessage => {
        Busy.set(false);
        toast.error('Failed to delete location.  Reason:  ' + errorMessage);
    };

    updateEditLocation = location => {
        let locations = this.state.globalLocations;
        let found= false;
        for (let i = 0; i < locations.length; i++) {
            if (locations[i].id === location.id) {
                locations[i]=location;
                found = true;
                break;
            }
        }

        if(!found){
            this.state.globalLocations.push(location);
        }
    };

    startSlider = () => {
        let numberOfVisibleSlides, sliderMargin;
        let windowWidth = $(window).width();
        let w = $('.info-details').width();

        if (windowWidth < 1000) {
            numberOfVisibleSlides = 1;
            sliderMargin = 20;

            this.bxslider = $('.info-details ul').bxSlider({
                auto: false,
                responsive: false,
                infiniteLoop: true,
                pager: false,
                preventDefaultSwipeY: true,
                speed: 500,
                minSlides: numberOfVisibleSlides,
                maxSlides: numberOfVisibleSlides,
                moveSlides: 1,
                slideWidth: Math.ceil(w / numberOfVisibleSlides),
                slideMargin: sliderMargin
            });
        }
    };

    render() {

        const appContext = this.context
        const { user, logout } = appContext

        return (
            <div id="ssLocationsProfile" className="grey-bg hs-bookings-container h-100">
                <div>
                    <header>
                        <ul className="breadcrumb">
                            <li>Account</li>
                            <li>Manage Locations</li>
                        </ul>
                        <h1 className="content-header-title">Manage Locations</h1>
                    </header>

                    <div>

                        {this.state.showHelp ?
                            <div className="info-locations relative">
                                <span className="close"
                                      onClick={() => this.setState({showHelp: 0})}
                                ><i className="fa fa-close" /> </span>
                                <div className="info-details">
                                    <div className="large-screen">
                                    <span>
                                        Things to know<br/>
                                        about Locations
                                    </span>
                                    </div>
                                    <div className="ul-container">
                                        <ul>
                                            <li className="search-image">
                                                <span>Locations allow Customers to <b>find your facilities</b> on the
                                                    SecurSpace Search screen.</span>
                                            </li>
                                            <li className="location-image">
                                                <span>Locations are <b>required to have basic info</b> specified
                                                    before they appear in search results.</span>
                                            </li>
                                            <li className="list-image">
                                                <span>The "Search Status" of a location lets you know if they are
                                                    ready to <b>appear in search results</b></span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            :
                            null}

                        <h2 className="float-left">My locations</h2>

                        <div className="w100 pull-left">
                            <div className="d-flex align-items-end justify-content-end">
                                <EmailVerifyToolTip
                                    title={"Please verify your email address to add a location."}
                                    isEmailVerified={this.props?.account?.emailVerified}
                                >
                                    <button type="button"
                                            onClick={() => this.handleCreateNewClick()}
                                            className="ss-button-secondary"
                                            disabled={!this.props?.account?.emailVerified}
                                            style={!this.props?.account?.emailVerified ? { opacity: 0.5, cursor: 'not-allowed' } : undefined}
                                    >
                                        {this.state.globalLocations && this.state.globalLocations.length > 0 ?
                                          "Create Another Location"
                                          :
                                          "Create Location"
                                        }
                                    </button>
                                </EmailVerifyToolTip>
                            </div>
                            {
                                this.state.globalLocations.map((location, index) =>
                                    <LocationListing key={index}
                                                     handleEditLocation={this.handleEditLocation}
                                                     updateEditLocation={this.updateEditLocation}
                                                     handleDeactivateLocationSuccess={this.handleDeactivateLocationSuccess}
                                                     handleDeactivateLocationFailure={this.handleDeactivateLocationFailure}
                                                     handleDeleteLocationSuccess={this.handleDeleteLocationSuccess}
                                                     handleDeleteLocationFailure={this.handleDeleteLocationFailure}
                                                     handleLogout={logout}
                                                     location={sanitizeData(location)}
                                                     account={user}
                                                     handleSupplierSelected={this.handleSelectedSupplier}
                                                     openEditModal={this.openCreateEditModal}
                                                     isEmailVerified={this.props?.account?.emailVerified}
                                    />
                                )
                            }
                        </div>
                        <div className='ss-supplier-active-bookings-endlist'>
                            <h6>You have reached the end of the list</h6>
                        </div>
                    </div>

                </div>

                {
                    this.state.createEditModalOpen &&
                    <CreateEditLocationsModalWrapper
                        closeModal={this.hideCreateEditModal}
                        updateEditLocation={this.updateEditLocation}
                        locationToEdit={this.state.locationToEdit}
                    />
                }
            </div>
        )
    }
}

/**
 * Injects router navigation and the `createLocationWizard` feature flag into the
 * legacy class component so create/edit can route to the new wizard when enabled.
 */
const LocationsProfileWithRouter = (props) => {
    const navigate = useNavigate();
    const { createLocationWizard } = useFeatureFlags();
    return (
        <LocationsProfile
            {...props}
            navigate={navigate}
            createLocationWizard={createLocationWizard}
        />
    );
};

export default LocationsProfileWithRouter;
